import React, { useEffect, useRef, useState } from 'react';
import { Smile } from 'lucide-react';

const EMOJIS = ['😀', '😊', '😂', '🙂', '😉', '😍', '🙏', '👍', '👋', '🎉', '✅', '⭐', '❤️', '💙', '🔥', '📞', '📅', '🏡', '💰', '🤝'];

/**
 * Emoji picker pinned to the message box's upper right.
 * @param {{onPick: (emoji: string) => void}} props
 * @returns {JSX.Element}
 */
export default function EmojiButton({ onPick }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  return (
    <div ref={ref} className="absolute top-2 right-2 z-10">
      <button
        type="button"
        aria-label="Insert emoji"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        className="w-8 h-8 rounded-full bg-civix-purple text-white flex items-center justify-center hover:bg-civix-purpleDeep transition cursor-pointer"
      >
        <Smile className="w-5 h-5" />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-48 p-2 grid grid-cols-5 gap-1 rounded-xl border border-civix-border bg-civix-panel shadow-2xl">
          {EMOJIS.map((e) => (
            <button key={e} type="button" onClick={() => { onPick(e); setOpen(false); }} className="text-lg rounded hover:bg-white/10 cursor-pointer">{e}</button>
          ))}
        </div>
      )}
    </div>
  );
}
